export default "__VITE_ASSET__CLIEJYaH__"